module.exports = __webpack_public_path__ + "static/media/bizKyc_logo.5356eb6b.png";